import { Box, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { Dispatch, SetStateAction, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { CustomEvent, Map } from "schemas/functions";
import { routes } from "schemas/routes";

import StyledTextField from "components/Styled/TextField";
import { makeDeepCopy } from "utils/updateLocalState";

import styles from "../styles";

interface IntroductionProps {
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  saveOnboardingForm: (onboardingForm: Map, pageType: string) => void;
}

const IntroductionForm = ({
  onboardingForm,
  setOnboardingForm,
  saveOnboardingForm,
}: IntroductionProps) => {
  const location = useLocation();
  const { currentUser } = useContext(OrganizationUserContext);

  const handleChange = (e: CustomEvent) => {
    const { name, value } = e.target;
    const copy = makeDeepCopy(onboardingForm);
    copy[name] = value;
    setOnboardingForm(copy);
  };

  const handleSubmit = (event: CustomEvent) => {
    event.preventDefault();

    saveOnboardingForm(onboardingForm, location.pathname);
  };

  return (
    <Box sx={{ mt: 6 }}>
      <Typography gutterBottom sx={styles.header}>
        Let us help you write customized emails ✏️
      </Typography>

      <Typography
        variant="subtitle1"
        paragraph
        textAlign={"center"}
        gutterBottom
      >
        The following questions help Bento's AI generate personalized pitch
        emails for you, which will appear on your recommendations page. <br />{" "}
        If you'd prefer to craft your own pitch email templates, you can do so
        on{" "}
        <Link style={{ textDecoration: "none" }} to={`/${routes.templates}`}>
          <Box component="span" sx={{ color: "purple.main" }}>
            your templates page
          </Box>
        </Link>
        .
      </Typography>
      <form onSubmit={handleSubmit}>
        <StyledTextField
          label="Write 2-3 sentences about yourself"
          fullWidth
          name="introduction"
          placeholder={`My name is ${
            currentUser?.name?.split(" ")?.[0] || `{name}`
          } ✨ and I am a fashion, beauty, and lifestyle content creator from...`}
          onChange={handleChange}
          multiline
          minRows={4}
          value={onboardingForm?.introduction || ""}
          styles={{ mb: 2 }}
        />
      </form>
    </Box>
  );
};

export default IntroductionForm;
